import { render, staticRenderFns } from "./footerTip.vue?vue&type=template&id=62c07dc6&scoped=true&"
import script from "./footerTip.vue?vue&type=script&lang=js&"
export * from "./footerTip.vue?vue&type=script&lang=js&"
import style0 from "./footerTip.vue?vue&type=style&index=0&id=62c07dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c07dc6",
  null
  
)

export default component.exports